/**
 * Revoked-integrations banner policy (TV1-2446 slice 7)
 *
 * Subscribes DIRECTLY to `backend.subscriptions.ExternalSystemsIntegrations` — not the legacy
 * `ProvideIntegrations` context, which ignores deletes, and not `channelsSyncPolicy`, which
 * filters to `connectorKind: 'salesChannel'` only. The banner must warn about a revoked
 * integration of ANY kind, so it keeps its own subscription and its own registration site
 * (`AuthenticatedLayout`, registered ONCE), independent of the channels/erps/etc. subdomains.
 */

import { Policy } from '@commandDrivenStateEngine/core/policies';
import { ClientLibraryType, ReadmodelChange } from '@bett3r-dev/teselly-client-library';
import { SystemIntegrationsReadmodel } from '@bett3r-dev/teselly-domain';
import { RevokedIntegrationsBannerState } from '../revokedIntegrationsBanner.state';
import { RevokedIntegrationsBannerCommand } from '../revokedIntegrationsBanner.commands';
import { reduceRevokedIntegrationsChange } from '../revokedIntegrations';

export const createRevokedIntegrationsBannerPolicy = (
  backend: ClientLibraryType
): Policy<RevokedIntegrationsBannerState, RevokedIntegrationsBannerCommand> => ({
  name: 'revoked-integrations-banner',

  init: ({ getState, dispatch }) => {
    const subscription = backend.subscriptions.ExternalSystemsIntegrations(
      {},
      ( change: ReadmodelChange<SystemIntegrationsReadmodel> ) => {
        const nextEntries = reduceRevokedIntegrationsChange( getState().entries, change );
        dispatch(
          { type: 'integrations/revokedBanner/setAll', payload: { entries: nextEntries }},
          { source: 'api' }
        );
      }
    );

    return () => subscription.close();
  }
});
